import React from "react";
import { Link } from "react-router-dom";

const BreadcrumbImage = ({ sellerData }) => {
  return (
    <section
      className="banner-inner bg-overlay z-1 position-relative py-72 bg-img bg-start"
      style={{
        backgroundImage: `url(${sellerData?.hero_image?.files?.large?.url})`,
      }}
    >
      <div className="container">
        <div className="banner-inner__content text-center">
          <h4 className="text-white mb-20 fw-semibold">
            {sellerData?.hero_title}
          </h4>
          <p className="text-white my-20">{sellerData?.description}</p>
          {sellerData?.buttons && (
            <Link
              to={sellerData?.buttons[0]?.attributes?.link}
              className="btn bg-main-product-50 hover-bg-main-product-50 rounded-8"
            >
              {sellerData?.buttons[0]?.attributes?.title}
            </Link>
          )}
        </div>
      </div>
    </section>
  );
};

export default BreadcrumbImage;
